module.exports = __webpack_public_path__ + "img/9.853630a8.png";